/* components */
import { Menu, MenuItem, Box } from '@mui/material'
import ListItemIcon from '@mui/material/ListItemIcon'
import LogoutIcon from '@mui/icons-material/Logout'

/* styles */
import useStyles from './useStyles'

export default function ProfileModal ({ open, onClose, anchorEl }) {
  const classes = useStyles()

  return (
    <>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={onClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <Box className={classes.container}>
          <MenuItem className={classes.text}>
            <ListItemIcon>
              <LogoutIcon />
            </ListItemIcon>
            Cerrar sesión
          </MenuItem>
        </Box>
      </Menu>
    </>
  )
}
